import {NotificationsUnreadCounterType, NotificationsType} from '../types'
import axiosV3 from '@/clientAPIV3.ts'

export type GetNotificationUnreadCountType = {
    count?: number
    last_read?: Date | string
}

export const getNotificationsHistory = async (params: {
    limit?: number
    responseType?: 'small' | 'extended'
    fromNotificatonId?: number
}): Promise<NotificationsType[]> => {
    const {data} = await axiosV3.get('/notifications', {params})
    return data
}

export const getNotificationUnreadCount = async (): Promise<NotificationsUnreadCounterType> => {
    const {data} = await axiosV3.get('/notifications/unread-count')
    return data
}

export const sendSeenNotifications = async (body: {fromNotificationId: number}) => {
    const {data} = await axiosV3.post('/notifications/seen', body)
    return data
}
